import Reflux from 'reflux';
import {
  StudentOverviewActions,
  StudentActions,
  AuthActions,
  AppActions
} from 'actions';
import SteelCompass from 'services/SteelCompass';

const pageLength = 1000;

const StudentOverviewStore = Reflux.createStore({
  listenables: [AuthActions, StudentActions, StudentOverviewActions],
  data: {
    user: {
      list: [],
      loading: true
    },
    invitation: {
      list: [],
      loading: true
    },
    activeList: 'user'
  },
  getInitialState() {
    return this.data;
  },
  init() {},
  changeList(activeList) {
    this.data = {
      ...this.data,
      activeList
    };
    this.trigger(this.data);
    if (this.data[activeList].list.length < 1) {
      this.getList(activeList);
    }
  },
  incarnate() {
    this.data = {
      user: {
        list: [],
        loading: true
      },
      invitation: {
        list: [],
        loading: true
      },
      activeList: 'user'
    };
    this.trigger(this.data);
  },
  getList(list, pageStart = 0) {
    this.data = {
      ...this.data,
      [list]: {
        ...this.data[list],
        loading: true
      }
    };
    this.trigger(this.data);
    SteelCompass.request(
      list,
      'prepareForUserList',
      {},
      list === 'user' ? pageStart : undefined,
      list === 'user' ? pageLength : undefined
    ).then(
      data => {
        if (data) {
          StudentOverviewActions.getListComplete(list, data, pageStart);
          if (data.length === pageLength) {
            this.getList(list, pageStart + pageLength);
          }
        } else {
          this.error(list);
        }
      },
      error => {
        this.error(list, error);
      }
    );
  },
  error(list, error) {
    this.data = {
      ...this.data,
      [list]: {
        ...this.data[list],
        loading: false
      }
    };
    this.trigger(this.data);
    AppActions.genericError(error);
  },
  sort_user(item1, item2) {
    if (item1.name.charAt(0) === ' ' && item2.name.charAt(0) === ' ') {
      const firstName = item1.name.substring(1).toLowerCase();
      const secondName = item2.name.substring(1).toLowerCase();

      return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
    } else if (item1.name.charAt(0) === ' ' && item2.name.charAt(0) !== ' ') {
      const firstName = item1.name.substring(1).toLowerCase();
      const secondName = item2.name.toLowerCase();

      return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
    } else if (item1.name.charAt(0) !== ' ' && item2.name.charAt(0) === ' ') {
      const firstName = item1.name.toLowerCase();
      const secondName = item2.name.substring(1).toLowerCase();

      return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
    } else {
      const firstName = item1.name.toLowerCase();
      const secondName = item2.name.toLowerCase();

      return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
    }
  },
  sort_invitation(item1, item2) {
    if (item1.email < item2.email) {
      return -1;
    }
    if (item1.email > item2.email) {
      return 1;
    }
    return 0;
  },
  sort(listName, list) {
    return list.sort(this['sort_' + listName]);
  },
  addTagComplete(userId, name) {
    this.data = {
      ...this.data,
      user: {
        ...this.data.user,
        list: this.data.user.list.map(user => {
          if (user.id === userId) {
            return {
              ...user,
              tagsMap: {
                ...user.tagsMap,
                [name]: 1
              }
            };
          }
          return user;
        })
      }
    };
    this.trigger(this.data);
  },
  expelComplete(userId) {
    this.data = {
      ...this.data,
      user: {
        ...this.data.user,
        list: this.data.user.list.filter(user => user.id !== userId)
      }
    };
    this.trigger(this.data);
  },
  removeTagComplete(userId, name) {
    this.data = {
      ...this.data,
      user: {
        ...this.data.user,
        list: this.data.user.list.map(user => {
          if (user.id === userId) {
            return {
              ...user,
              tagsMap: {
                ...user.tagsMap,
                [name]: 0
              }
            };
          }
          return user;
        })
      }
    };
    this.trigger(this.data);
  },
  getListComplete(list, data, pageStart) {
    if (pageStart === 0) {
      this.data = {
        ...this.data,
        [list]: {
          list: this.sort(list, data),
          loading: data.length === pageLength
        }
      };
    } else {
      this.data = {
        ...this.data,
        [list]: {
          list: this.sort(list, [...this.data[list].list, ...data]),
          loading: data.length === pageLength
        }
      };
    }
    this.trigger(this.data);
  }
});

export default StudentOverviewStore;



// WEBPACK FOOTER //
// ./src/js/stores/StudentOverview.js